export default __webpack_public_path__ + "static/media/sololeveling.7d998321.jpg";